export const MONITOR_LIST = 'lists'
